import type { ReactElement } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useOrganisationFeaturesOf } from 'app/hooks/useOrganisationFeatures';
import CenteredSpinner from 'app/shared-components/common/CenteredSpinner';
import { PlanFeaturesErrorState } from 'app/shared-components/PlusPaywall';

import { ONBOARDING_PATHS } from './constants/paths';
import { useViewedOrganisationId, useWebBuilderAccess } from '../../hooks/useWebBuilderAccess';
import LegacySalesPage from './LegacySalesPage';
import PlusSalesPage from './PlusSalesPage';

const SalesPage = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const organisationId = useViewedOrganisationId();
  const { hasWebBuilderAccess, isLoading, isError, retry } = useWebBuilderAccess();
  const { pricingLaunched } = useOrganisationFeaturesOf(organisationId);

  if (isError) return <PlanFeaturesErrorState onRetry={retry} />;
  if (isLoading) return <CenteredSpinner />;

  // The whole page is an upsell, so organisations that already own the builder are dropped
  // straight into the wizard — including anyone who lands here from a bookmarked URL.
  if (hasWebBuilderAccess) {
    return (
      <Navigate
        to={{ pathname: ONBOARDING_PATHS.colour, search: searchParams.toString() }}
        replace
      />
    );
  }

  if (pricingLaunched) return <PlusSalesPage organisationId={organisationId} />;
  return <LegacySalesPage />;
};

export default SalesPage;
